import React, { Fragment, useState } from "react";
import { Popover, Transition, Menu } from "@headlessui/react";
import { MenuIcon, XIcon, ChevronDownIcon, ChevronUpIcon, ChevronRightIcon } from "@heroicons/react/outline";
import { Link } from "react-router-dom";
import config from "../../../config/index.json";
import LanguageSwitcher from "../../../LanguageSwitcher/LanguageSwitcher";
import { useLanguage, getTranslation } from "../../utils/translations";


const Header = () => {
  const { navigation, company } = config;
  const { name: companyName, logo } = company;
  const currentLang = useLanguage();

  const [open, setOpen] = useState(false);

  const [submenuOpen, setSubmenuOpen] = useState(null);
  const [productDropdownOpen, setProductDropdownOpen] = useState(false);
  const [eBookDropdownOpen, seteBookDropdownOpen] = useState(false);
  const [ArchiveDropdownOpen, seteArchiveDropdownOpen] = useState(false);
  const [imageDropdownOpen, setImageDropdownOpen] = useState(false);
  const [PDFDropdownOpen, setPDFDropdownOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);

  const closeAllMenus = () => {
    setOpen(false);
    setProductDropdownOpen(false);
    setSubmenuOpen(null);
    setProductDropdownOpen(false);
    seteArchiveDropdownOpen(false);
    seteBookDropdownOpen(false);
    setImageDropdownOpen(false);
    setPDFDropdownOpen(false);
    setSubmenuOpen(null);
    setOpenMenu(null);

  };

  return (
    <Popover>
      <div className="relative pt-6 px-4 sm:px-6 lg:px-8 font-sans">
        <div className="max-w-5xl mx-auto">
          <nav
            className="flex items-center justify-between"
            aria-label="Global"
          >
            <div className="flex items-center flex-shrink-0">
              <Link to={currentLang === 'fr' ? '/fr' : '/'} className="flex items-center">
                <span className="sr-only">{companyName}</span>
                <img alt="logo" className="h-12 md:h-16 w-auto" src={logo} width="190" height="64" />
              </Link>
            </div>

            {/* Language Switcher */}
            <div className="hidden md:flex items-center">
              <LanguageSwitcher />
            </div>

            {/* <div className="hidden md:flex md:space-x-8 mr-6">
              {navigation.map((item, index) => (
                <div key={index} className="relative">
                  {item.Product && (
                    <Menu as="div" className="relative inline-block text-left mr-6">
                      <div>
                        <Menu.Button
                          className="inline-flex items-center text-gray-500 hover:text-gray-900 font-medium"
                          onClick={() => setOpen((prev) => !prev)}
                        >
                          File
                          <ChevronDownIcon className="ml-1 h-5 w-5" aria-hidden="true" />
                        </Menu.Button>
                      </div>

                      <Transition
                        as={Fragment}
                        show={open}
                        enter="transition ease-out duration-200"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="transition ease-in duration-150"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                      >
                        <Menu.Items
                          className="absolute left-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50"
                          onClick={closeAllMenus}
                        >
                          <div className="py-1">
                            {item.Product.map((format) => (
                              <Menu as="div" key={format.name} className="relative">
                                <Menu.Button className="w-full flex items-center justify-between px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                                  {format.name}
                                  <ChevronRightIcon className="h-4 w-4 ml-1" />
                                </Menu.Button>

                                <Transition
                                  as={Fragment}
                                  enter="transition ease-out duration-200"
                                  enterFrom="opacity-0 scale-95"
                                  enterTo="opacity-100 scale-100"
                                  leave="transition ease-in duration-150"
                                  leaveFrom="opacity-100 scale-100"
                                  leaveTo="opacity-0 scale-95"
                                >
                                  <Menu.Items className="absolute left-full top-0 mt-0 ml-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                                    {format.subItems.map((tool) => (
                                      <Menu.Item key={tool.name}>
                                        {({ active }) => (
                                          <Link
                                            to={tool.href}
                                            onClick={closeAllMenus}
                                          >
                                            <span
                                              className={`block px-4 py-2 text-sm ${active
                                                ? "bg-gray-100 text-gray-900"
                                                : "text-gray-700"
                                                }`}
                                            >
                                              {tool.name}
                                            </span>
                                          </Link>
                                        )}
                                      </Menu.Item>
                                    ))}
                                  </Menu.Items>
                                </Transition>
                              </Menu>
                            ))}

                            <Menu.Item key="AllConverter">
                              {({ active }) => (
                                <Link
                                  to="/AllConverter"
                                  onClick={closeAllMenus}
                                >
                                  <span
                                    className={`block px-4 py-2 text-sm ${active
                                      ? "bg-gray-100 text-gray-900"
                                      : "text-gray-700"
                                      }`}
                                  >
                                    AllConverter
                                  </span>
                                </Link>
                              )}
                            </Menu.Item>
                          </div>
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  )}

                  {item.eBook && (
                    <Menu as="div" className="relative inline-block text-left ml-6 mr-6">
                      <Menu.Button className="inline-flex items-center text-gray-500 hover:text-gray-900 font-medium">
                        eBook
                        <ChevronDownIcon
                          className="ml-1 h-5 w-5"
                          aria-hidden="true"
                        />
                      </Menu.Button>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-200"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="transition ease-in duration-150"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                      >
                        <Menu.Items className="absolute left-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                          <div className="py-1">
                            {item.eBook.map((subItem) => (
                              <Menu.Item key={subItem.name}>
                                {({ active }) => (
                                  <Link to={subItem.href}>
                                    <span
                                      className={`block px-4 py-2 text-sm ${active
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700"
                                        }`}
                                    >
                                      {subItem.name}
                                    </span>
                                  </Link>
                                )}
                              </Menu.Item>
                            ))}
                          </div>
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  )}

                  {item.Archive && (
                    <Menu as="div" className="relative inline-block text-left ml-6 mr-6">
                      <Menu.Button className="inline-flex items-center text-gray-500 hover:text-gray-900 font-medium">
                        Archive
                        <ChevronDownIcon
                          className="ml-1 h-5 w-5"
                          aria-hidden="true"
                        />
                      </Menu.Button>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-200"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="transition ease-in duration-150"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                      >
                        <Menu.Items className="absolute left-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                          <div className="py-1">
                            {item.Archive.map((subItem) => (
                              <Menu.Item key={subItem.name}>
                                {({ active }) => (
                                  <Link to={subItem.href}>
                                    <span
                                      className={`block px-4 py-2 text-sm ${active
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700"
                                        }`}
                                    >
                                      {subItem.name}
                                    </span>
                                  </Link>
                                )}
                              </Menu.Item>
                            ))}
                          </div>
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  )}
                  {item.Image && (
                    <Menu as="div" className="relative inline-block text-left ml-6 mr-6">
                      <Menu.Button className="inline-flex items-center text-gray-500 hover:text-gray-900 font-medium">
                        Image
                        <ChevronDownIcon
                          className="ml-1 h-5 w-5"
                          aria-hidden="true"
                        />
                      </Menu.Button>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-200"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="transition ease-in duration-150"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                      >
                        <Menu.Items className="absolute left-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                          <div className="py-1">
                            {item.Image.map((subItem) => (
                              <Menu.Item key={subItem.name}>
                                {({ active }) => (
                                  <Link to={subItem.href}>
                                    <span
                                      className={`block px-4 py-2 text-sm ${active
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700"
                                        }`}
                                    >
                                      {subItem.name}
                                    </span>
                                  </Link>
                                )}
                              </Menu.Item>
                            ))}
                          </div>
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  )}

                  {item.PDF && (
                    <Menu as="div" className="relative inline-block text-left ml-6 mr-6">
                      <Menu.Button className="inline-flex items-center text-gray-500 hover:text-gray-900 font-medium">
                        PDF Tools
                        <ChevronDownIcon
                          className="ml-1 h-5 w-5"
                          aria-hidden="true"
                        />
                      </Menu.Button>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-200"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="transition ease-in duration-150"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                      >
                        <Menu.Items className="absolute left-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                          <div className="py-1">
                            {item.PDF.map((subItem) => (
                              <Menu.Item key={subItem.name}>
                                {({ active }) => (
                                  <Link to={subItem.href}>
                                    <span
                                      className={`block px-4 py-2 text-sm ${active
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700"
                                        }`}
                                    >
                                      {subItem.name}
                                    </span>
                                  </Link>
                                )}
                              </Menu.Item>
                            ))}
                          </div>
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  )}
                </div>
              ))}


              <Link
                to="/ContactUS"
                className="font-medium text-gray-500 hover:text-gray-900"
              >
                Contact US
              </Link>
            </div>

            <div className="flex md:hidden">
              <Popover.Button className="bg-background rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-secondary">
                <MenuIcon className="h-6 w-6" aria-hidden="true" />
              </Popover.Button>
            </div> */}
          </nav>
        </div>

        {/* <Transition
          as={Fragment}
          enter="duration-150 ease-out"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="duration-100 ease-in"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Popover.Panel
            focus
            className="absolute z-20 top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden"
          >
            <div className="rounded-lg shadow-md bg-white ring-1 ring-black ring-opacity-5 overflow-hidden">
              <div className="px-5 pt-4 flex items-center justify-between">
                <div>
                  <img className="h-8 w-auto" src={logo} alt={companyName} />
                </div>
                <div className="-mr-2">
                  <Popover.Button className="bg-background rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-secondary">
                    <XIcon className="h-6 w-6" aria-hidden="true" />
                  </Popover.Button>
                </div>
              </div>

              <div className="px-2 pt-2 pb-3 space-y-1">
                {navigation.map((item, index) => (
                  <div key={index}>
                    {item.Product && (
                      <>
                        <button
                          className="block px-3 py-2 text-base font-medium text-gray-700 w-full text-left flex items-center justify-between"
                          onClick={() => {
                            setOpenMenu((prev) => (prev === "File" ? null : "File"));
                            setSubmenuOpen(null);
                          }}
                        >
                          File
                          <ChevronDownIcon
                            className={`h-5 w-5 ${openMenu === "File" ? "transform rotate-180" : ""
                              }`}
                          />
                        </button>
                        {openMenu === "File" && (
                          <div className="mt-1 space-y-1 pl-4">
                            {item.Product && (
                              <>
                                <button
                                  className="block px-3 py-2 text-base font-medium text-gray-700 w-full text-left flex items-center justify-between"
                                  onClick={() => {
                                    setOpenMenu((prev) => (prev === "File" ? null : "File"));
                                    setSubmenuOpen(null);
                                  }}
                                >
                                  File
                                  <ChevronDownIcon
                                    className={`h-5 w-5 ${openMenu === "File" ? "transform rotate-180" : ""}`}
                                  />
                                </button>
                                {openMenu === "File" && (
                                  <div className="mt-1 space-y-1 pl-4">
                                    {item.Product.map((format) => (
                                      <div key={format.name}>
                                        <button
                                          className="w-full flex items-center justify-between px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                          onClick={() =>
                                            setSubmenuOpen((prev) =>
                                              prev === format.name ? null : format.name
                                            )
                                          }
                                        >
                                          {format.name}
                                          <ChevronDownIcon
                                            className={`h-5 w-5 ${submenuOpen === format.name ? "transform rotate-180" : ""}`}
                                          />
                                        </button>
                                        {submenuOpen === format.name && (
                                          <div className="mt-1 pl-4 space-y-1">
                                            {format.subItems.map((tool) => (
                                              <Link
                                                to={tool.href}
                                                key={tool.name}
                                                onClick={closeAllMenus} // Close all menus after selecting
                                              >
                                                <span className="block px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100">
                                                  {tool.name}
                                                </span>
                                              </Link>
                                            ))}
                                          </div>
                                        )}
                                      </div>
                                    ))}

                                    <div>
                                      <Link
                                        to="/AllConverter"
                                        className="w-full flex items-center justify-between px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                        onClick={closeAllMenus} // Close all menus after selecting
                                      >
                                        AllConverter
                                      </Link>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}

                          </div>
                        )}
                      </>
                    )}

                    {item.eBook && (
                      <>
                        <button
                          className="block px-3 py-2 text-base font-medium text-gray-700 w-full text-left flex items-center justify-between"
                          onClick={() =>
                            seteBookDropdownOpen(!eBookDropdownOpen)
                          }
                        >
                          eBook
                          <ChevronDownIcon
                            className={`h-5 w-5 ${eBookDropdownOpen ? "transform rotate-180" : ""
                              }`}
                          />
                        </button>
                        {eBookDropdownOpen && (
                          <div className="mt-1 space-y-1 pl-4">
                            {item.eBook.map((subItem) => (
                              <Popover.Button
                                key={subItem.name}
                                as={Link}
                                to={subItem.href}
                              >
                                <span className="block px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 rounded-md">
                                  {subItem.name}
                                </span>
                              </Popover.Button>
                            ))}
                          </div>
                        )}
                      </>
                    )}
                    {item.Archive && (
                      <>
                        <button
                          className="block px-3 py-2 text-base font-medium text-gray-700 w-full text-left flex items-center justify-between"
                          onClick={() =>
                            seteArchiveDropdownOpen(!ArchiveDropdownOpen)
                          }
                        >
                          Archive
                          <ChevronDownIcon
                            className={`h-5 w-5 ${ArchiveDropdownOpen ? "transform rotate-180" : ""
                              }`}
                          />
                        </button>
                        {ArchiveDropdownOpen && (
                          <div className="mt-1 space-y-1 pl-4">
                            {item.eBook.map((subItem) => (
                              <Popover.Button
                                key={subItem.name}
                                as={Link}
                                to={subItem.href}
                              >
                                <span className="block px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 rounded-md">
                                  {subItem.name}
                                </span>
                              </Popover.Button>
                            ))}
                          </div>
                        )}
                      </>
                    )}
                    {item.Image && (
                      <>
                        <button
                          className="block px-3 py-2 text-base font-medium text-gray-700 w-full text-left flex items-center justify-between"
                          onClick={() =>
                            setImageDropdownOpen(!imageDropdownOpen)
                          }
                        >
                          {getTranslation('navigation.image', currentLang)}
                          <ChevronDownIcon
                            className={`h-5 w-5 ${imageDropdownOpen ? "transform rotate-180" : ""
                              }`}
                          />
                        </button>
                        {imageDropdownOpen && (
                          <div className="mt-1 space-y-1 pl-4">
                            {item.Image.map((subItem) => (
                              <Popover.Button
                                key={subItem.name}
                                as={Link}
                                to={subItem.href}
                              >
                                <span className="block px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 rounded-md">
                                  {subItem.name}
                                </span>
                              </Popover.Button>
                            ))}
                          </div>
                        )}
                      </>
                    )}
                    {item.PDF && (
                      <>
                        <button
                          className="block px-3 py-2 text-base font-medium text-gray-700 w-full text-left flex  justify-between"
                          onClick={() => setPDFDropdownOpen(!PDFDropdownOpen)}
                        >
                          {getTranslation('navigation.pdf', currentLang)}
                          <ChevronDownIcon
                            className={`h-5 w-5 ${PDFDropdownOpen ? "transform rotate-180" : ""
                              }`}
                          />
                        </button>
                        {PDFDropdownOpen && (
                          <div className="mt-1 space-y-1 pl-4 text-left">
                            {item.PDF.map((subItem) => (
                              <Popover.Button
                                key={subItem.name}
                                as={Link}
                                to={subItem.href}
                              >
                                <span className="block px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 rounded-md">
                                  {subItem.name}
                                </span>
                              </Popover.Button>
                            ))}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                ))}

                <Link
                  to="/ContactUS"
                  className="block px-3 py-2 text-left text-base font-medium text-gray-700 hover:bg-gray-100 rounded-md"
                >
                  {getTranslation('navigation.contact', currentLang)}
                </Link>
              </div>
            </div>
          </Popover.Panel>
        </Transition> */}
      </div>
    </Popover>
  );
};

export default Header;
